export class Category {
    id: any = 0;
    title = '';
    status = 0;
    extra_config: any;
    parent_id: any = 0;
    photo = '';
    is_feature = 0;
}
